// extracted by mini-css-extract-plugin
export var carrierTab = "_58-0";
export var carrierTabActive = "_58-1 _58-0";
export var carrierTabInactive = "_58-2 _58-0";
export var carrierTabLabel = "_58-3";
export var carrierTabLabelActive = "_58-4 _58-3";
export var carrierTabLabelInactive = "_58-5 _58-3";
export var carrierTabPercentage = "_58-6";
export var carrierTabPercentageActive = "_58-7 _58-6";
export var carrierTabPercentageInactive = "_58-8 _58-6";
export var carrierTabWinnable = "_58-9";
export var carrierTabWinnableActive = "_58-a _58-9";
export var carrierTabWinnableInactive = "_58-b _58-9";
export var comparisonContainer = "_58-d";
export var missingRateButton = "_58-n";
export var missingRateButtonActive = "_58-o _58-n";
export var missingRateButtonInactive = "_58-p _58-n";
export var missingRateButtonLabel = "_58-q";
export var missingRateButtonLabelActive = "_58-r _58-q";
export var missingRateButtonLabelInactive = "_58-s _58-q";
export var sidebar = "_58-c";
export var strategyButton = "_58-e";
export var strategyButtonActive = "_58-f _58-e";
export var strategyButtonDescription = "_58-k";
export var strategyButtonDescriptionActive = "_58-l _58-k";
export var strategyButtonDescriptionInactive = "_58-m _58-k";
export var strategyButtonInactive = "_58-g _58-e";
export var strategyButtonLabel = "_58-h";
export var strategyButtonLabelActive = "_58-i _58-h";
export var strategyButtonLabelInactive = "_58-j _58-h";
export var unitToggleButton = "_58-t";
export var unitToggleButtonActive = "_58-u _58-t";
export var unitToggleButtonInactive = "_58-v _58-t";
export var unitToggleButtonLabel = "_58-w";
export var unitToggleButtonLabelActive = "_58-x _58-w";
export var unitToggleButtonLabelInactive = "_58-y _58-w";